import { define } from '@directive'
import attributeChanged, { enumerating } from '@directive/attributeChanged'
import { paint, retouch } from '@dom'
import Echo from '@echo'
import { Height, Hidden, Identity, role, Width } from '@mixin'
import component from './component.js'
import { DIRECTIONS } from './direction.js'
import style from './style.js'

@define('kb-stack')
@paint(component, style)
class Stack extends Identity(Hidden(Width(Height(Echo(HTMLElement))))) {
  #align
  #direction
  #internals
  #justify
  #spacing

  get align() {
    return (this.#align ??= 'start')
  }

  @attributeChanged('align')
  @retouch
  set align(value) {
    this.#align = value
  }

  get direction() {
    return (this.#direction ??= DIRECTIONS.ROW)
  }

  // `enumerating(DIRECTIONS)` only propagates a value in the known tokens —
  // an unknown one never reaches the setter, so the CSS interpolation in
  // style.js never sees an invalid keyword.
  @attributeChanged('direction', enumerating(DIRECTIONS))
  @retouch
  set direction(value) {
    this.#direction = value
  }

  // A layout box with no meaning of its own: declaring it presentational
  // keeps it from adding a generic node around whatever it arranges.
  get [role]() {
    return 'none'
  }

  get internals() {
    return (this.#internals ??= this.attachInternals())
  }

  get justify() {
    return (this.#justify ??= 'flex-start')
  }

  @attributeChanged('justify')
  @retouch
  set justify(value) {
    this.#justify = value
  }

  get spacing() {
    return (this.#spacing ??= 'xs')
  }

  @attributeChanged('spacing')
  @retouch
  set spacing(value) {
    this.#spacing = value
  }

  constructor() {
    super()
    this.attachShadow({ mode: 'open' })
  }
}

export default Stack
